import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import de from 'vuetify/lib/locale/de';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
      locales: { de },
      current: 'de',
    },
  icons: {
    iconfont: 'md',
  },
  theme: {
    options: {
        customProperties: true
    },
    themes: {
        light: {
            primary: "#FF6600",
            secondary: "#171b34",
            accent: "3D87E4",
            alert: "FF3333"
        }
    }
}
});
